// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1wOpg","row1":"_2qeE6","row2":"_3N5CJ","row3":"cHFVw","content":"_1AXaT","title":"_2AD9h","list-items":"_1oaFw"};